import { SyntheticEvent } from "react";
import handleTouch from "../../../../../common/helpers/handleTouch";
import { IScoreEditorThis } from "../../../../../common/types";
import { getRealLength } from "./getRealLength";

export const handleRemoveNote = async function (this: IScoreEditorThis, e: KeyboardEvent | MouseEvent | TouchEvent, isRhytNotation?: boolean) {
    if (!(await handleTouch(e))) return;
    const { activeVoice } = this.state;
    const score = { ...this.state.score };
    const bars = score["bars" + (activeVoice || "")];
    let currentBarIndex = bars.length - 1;
    let startBar = 0;
    if (bars[0] === null) startBar = 1;
    if (bars[currentBarIndex].notes.length === 0 && bars.length !== startBar + 1) {
        bars.pop();
        currentBarIndex--;
        if (!isRhytNotation) {
            score.signatures.forEach((signature, index) => {
                if (signature.bar! > bars.length - 1) {
                    score.signatures.splice(index, 1);
                }
            });
        }
        if (!score.keyChanges) {
            score.keyChanges = [];
        }
        score.keyChanges.forEach((keyChange, index) => {
            if (keyChange.bar > bars.length - 1) {
                score.keyChanges.splice(index, 1);
            }
        });
    }
    let removedNote = bars[currentBarIndex].notes.pop();
    if (removedNote && removedNote.t) {
        score.trupletLeft! += getRealLength(removedNote) * 2;
    } else {
        score.trupletLeft = 0;
    }
    this.setState({ score, fullBar: false });
};